import styled, { css } from 'styled-components';

import { Container, appearFromLeft } from '../styles';

interface InputWrapperProps {
  flexSize?: number;
  isTypeText?: boolean;
  ml?: number;
  mr?: number;
}

export const FormFirstSectionWrapper = styled(Container)`
  min-height: ${({ increaseMinHeight }) => (increaseMinHeight ? 600 : 0)}px;
  animation: ${appearFromLeft} 1s;
  flex-direction: column;

  flex: 1;

  label {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 10px;

    color: #475466;
  }
`;

export const ChooseNameAndSemesterWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const InputWrapper = styled.div<InputWrapperProps>`
  flex-direction: column;
  flex: ${({ flexSize }) => flexSize || 1};
  margin-left: ${({ ml }) => ml || 0}px;
  margin-right: ${({ mr }) => mr || 0}px;

  ${({ isTypeText }) =>
    isTypeText
      ? css`
          input {
            padding: 10px 17px;
            background: #ffffff;
            border: 1px solid #e4e9f0;
            box-sizing: border-box;
            border-radius: 5px;
            width: 100%;
            font-weight: 500;
            font-size: 12px;
            line-height: 13px;
            color: #7a8799;
            height: 46px;
          }
        `
      : null}
`;

export const SemesterSelector = styled.div`
  flex: 1;
  width: 100%;
  flex-direction: column;
`;

export const ChooseCoursesAndDeadLine = styled.div`
  display: flex;
  width: 100%;
  margin-top: 35px;
  justify-content: space-evenly;
`;

export const InputCheckboxContainer = styled.div`
  display: flex;
  box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.1);
  border-radius: 6px;
  background: #ffffff;
  padding: 15px 20px;
  justify-content: space-between;
  align-items: center;
  margin-right: 45px;
  height: 46px;
`;

export const CheckboxOption = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  label {
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #98a2b3;
    margin: 0 0 0 10px;

    &:hover {
      cursor: pointer;
    }
  }

  input {
    border: 1px solid #98a2b2;
    border-radius: 2px;

    &:hover {
      cursor: pointer;
    }
  }
`;
